import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { translate } from '@utils/i18n';
import { attachmentsKeys } from './queryKeys';
import { fetchInspectionReports, addReport, removeReport } from '../services/AttachmentsService';
const NS = 'features.proposals.attachments_step';
export function useInspectionReports(proposalId, url, enabled) {
    return useQuery({
        queryKey: attachmentsKeys.inspectionReports(proposalId),
        queryFn: () => fetchInspectionReports(url),
        enabled,
        staleTime: 60 * 1000
    });
}
export function useAddReport(proposalId, addReportUrl) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (reportId) => addReport(addReportUrl, reportId, proposalId),
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: attachmentsKeys.list(proposalId) });
            void queryClient.invalidateQueries({ queryKey: attachmentsKeys.inspectionReports(proposalId) });
        },
        onError: () => {
            toast.error(translate('error_add_report', { namespace: NS }));
        }
    });
}
export function useRemoveReport(proposalId, removeReportUrl) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (reportId) => removeReport(removeReportUrl, reportId, proposalId),
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: attachmentsKeys.list(proposalId) });
            void queryClient.invalidateQueries({ queryKey: attachmentsKeys.inspectionReports(proposalId) });
        },
        onError: () => {
            toast.error(translate('error_remove_report', { namespace: NS }));
        }
    });
}
